module.exports = __webpack_public_path__ + "img/cart-flatbed-suitcase.a4428f76.svg";